<template>
    <div class="titlebar">
        <div class="titlebar__inner">
            <div class="titlebar__logo">
                <img src="../assets/kc-web-logo.svg" alt />
            </div>

            <div class="titlebar__buttons">
                <ButtonLink
                    title="Donate Online"
                    :link="donateOnlineURL"
                ></ButtonLink>
                <ButtonLink
                    icon="download"
                    title="Download Pledge Form"
                    :link="pledgeFormURL"
                ></ButtonLink>
                <div class="text-links">
                    <a :href="standingOrderURL">Standing Order Mandate</a>
                    <a :href="enduringCertificateURL">
                        CHY3 Enduring Certificate
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.titlebar {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 5;
    padding: 1rem 0 0;
    pointer-events: none;

    &__inner {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        max-width: 95%;
        margin: 0 auto;

        @include iego {
            justify-content: space-between;
        }
    }

    &__logo {
        width: 259px;
        height: 86px;
        margin-left: 0;
        margin-right: auto;
        pointer-events: all;
    }

    &__buttons {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-end;
        pointer-events: none;

        a {
            pointer-events: all;
        }

        @include mobile {
            display: none;
        }

        .button_link {
            border: none;
            &:first-of-type {
                background: var(--secondary_colour);
                color: var(--primary_colour);
                margin-right: 1rem;

                &:hover {
                    color: var(--secondary_colour);
                    background: var(--primary_colour);
                }
            }

            @include tablet-and-mobile {
                &_primary {
                    border: 1px solid var(--secondary_colour);
                }
            }
            @include iego {
                &_primary {
                    border: 1px solid var(--secondary_colour);
                }
            }
        }

        .text-links {
            flex-basis: 100%;
            text-align: right;
            margin-top: 0.5rem;

            a {
                color: var(--quaternary_colour);
                font-size: 0.875rem;
                font-weight: 600;
                text-decoration: none;
                margin-right: 1.5rem;
                text-transform: uppercase;

                &:last-child {
                    margin-right: 0;
                }
            }
        }
    }
}
</style>
